<template>
  <div id="right">
<!--       <div class="top">-->
<!--            <el-button-group>-->
<!--                    <el-button :type="primary1" @click='choose("RightPan")'>业绩分析</el-button>-->
<!--                    <el-button :type="primary2" @click='choose("RightData")'>数据大盘</el-button>-->
<!--            </el-button-group>-->
<!--       </div>-->
       <div class="bottom">
           <keep-alive :include="componentId">
               <component :is="componentId" ></component>
           </keep-alive>
       </div>
  </div>
</template>

<script>
import RightData  from './_rightData.vue'
import RightPan  from './_rightPan.vue'
export default {
    components:{
       RightData,
       RightPan
    },
   data() {
       return {
           componentId:"RightPan",
           primary1:'primary',
           primary2:'',
       }
   },
   methods: {
       choose(val){
           this.componentId = val;
           if(val === 'RightData') {
               this.primary1='';
               this.primary2 = 'primary'
            } else {
                 this.primary1='primary';this.primary2 = ''
            }
       }
   },

}
</script>

<style lang="less" scoped>
.top{
    background-color: #fff;
    padding: 20px;
    margin-bottom: 10px;
}
.bottom{
    width: 100%;
}
</style>
